import { FC } from "react";
import {
  VENDOR_ACTIVE_STATUS_ACTIVE,
  VENDOR_ACTIVE_STATUS_IN_ACTIVE,
  TVendorActiveStatus
} from "@utils/constants";
import { Flex, Tag } from "antd";
import { useAntToken } from "@hooks/common/useAntToken";
import { useBreakpoints } from "@hooks/common/useBreakPoints";

interface IVendorsActiveTagProps {
  status: TVendorActiveStatus;
}
const VendorsActiveTag: FC<IVendorsActiveTagProps> = ({ status}) => {
  const { token } = useAntToken();
  const { isScreenXS } = useBreakpoints();
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  const fontWeightMedium = token.fontWeightMedium;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  const fontSizeXS = token.fontSizeXS;
  const commonStyles = {
    boxShadow: token.boxShadow,
    fontWeight: fontWeightMedium,
    fontSize: isScreenXS ? fontSizeXS : token.fontSize
  };

  const commonFlexStyles = {
    height: "24px",
    width: "104px"
  };
  return (
    <>
      {status === VENDOR_ACTIVE_STATUS_ACTIVE && (
        <Flex justify="start" align="middle" style={!isScreenXS ? commonFlexStyles : {}}>
          <Tag
            bordered={true}
            color={token.colorSuccess}
            style={{
              ...commonStyles,
              background: token.colorSuccessBgHover,
              color: token.colorText
            }}>
            Active
          </Tag>
        </Flex>
      )}
      {status === VENDOR_ACTIVE_STATUS_IN_ACTIVE && (
        <Flex justify="start" align="middle" style={!isScreenXS ? commonFlexStyles : {}}>
          <Tag
            bordered={true}
            color="error"
            style={{
              ...commonStyles,
              background: token.colorErrorBgHover,
              color: token.colorText
            }}>
            In Active
          </Tag>
        </Flex>
      )}
    </>
  );
};

export default VendorsActiveTag;
